export const PRACTICE_MANAGEMENT_COUNTRY_OPTIONS = ["global", "de", "at", "ch", "pl", "gb", "cz", "sk", "hu", "us"] as const;

/** Countries shown in the country <Select> dropdown. "at", "ch", "sk" and "us" are excluded as they are not yet supported. */
export const PRACTICE_MANAGEMENT_COUNTRY_SELECT_OPTIONS = ["global", "de", "pl", "gb", "cz", "hu"] as const;

/** Single source of truth for the practice management tabs, shared by the PracticeManagement page and AdminNav. */
export const PRACTICE_MANAGEMENT_TABS = [
  { key: "crop-parameters", label: "Crop Parameters" },
  { key: "organic-fertilizer-parameters", label: "Organic Fertilizer Parameters" },
  { key: "piglet-parameters", label: "Piglet Parameters" },
  { key: "pork-parameters", label: "Pork Parameters" },
  { key: "crop-emission-factors", label: "Crop Emission Factors" },
  { key: "mineral-fertilizer-emission-factors", label: "Mineral Fertilizer Emission Factors" },
  { key: "organic-fertilizer-emission-factors", label: "Organic Fertilizer Emission Factors" },
  { key: "plant-protection-emission-factors", label: "Plant Protection Emission Factors" },
  { key: "seeding-emission-factors", label: "Seeding Emission Factors" },
  { key: "tillage-emission-factors", label: "Tillage Emission Factors" },
  { key: "fertilizer-application-emission-factors", label: "Fertilizer Application Emission Factors" },
  { key: "soil-emission-factors", label: "Soil Emission Factors" },
  { key: "utility-emission-factors", label: "Utility Emission Factors" },
  { key: "version-notes", label: "Version Notes" },
] as const;
